const filters = document.querySelectorAll('.js-asside-filter-desktop'); 

filters.forEach((filter)=>{
    filter.addEventListener('click', (e)=>{
        e.preventDefault();

        if(!filter.classList.contains('is-active')){
            const wasActive = document.querySelector('.js-asside-filter-desktop.is-active');
            const wasContainerActive = document.querySelector('.js-asside-container-desktop.is-active');
            
            const containerActive = document.querySelector('.' + filter.dataset.open);

            wasActive.classList.remove('is-active');
            wasContainerActive.classList.remove('is-active');

            filter.classList.add('is-active');
            containerActive.classList.add('is-active');
        }
    })
})

const filtersMobile = document.querySelectorAll('.js-asside-filter-mobile');

filtersMobile.forEach((filter)=>{
    filter.addEventListener('click', (e)=>{
        e.preventDefault();

        if(!filter.classList.contains('is-active')){
            const wasActive = document.querySelector('.js-asside-filter-mobile.is-active');
            const wasContainerActive = document.querySelector('.js-asside-container-mobile.is-active');
            
            const containerActive = document.querySelector('.' + filter.dataset.open);

            wasActive.classList.remove('is-active');
            wasContainerActive.classList.remove('is-active');

            filter.classList.add('is-active');
            containerActive.classList.add('is-active');
        }
    })
})